import { RadioGroupOptions } from '@myriadgenetics/mgh-types';

export const OPTION_VALUES_MAPPING: { [key: string]: boolean } = {
  '1': true,
  true: true,
  '0': false,
  false: false,
};

export type CleanedRadioGroupOption = Omit<RadioGroupOptions, 'optionLabel'>;
